import jump from 'jump.js'
export default hero => {
  const loader = hero.querySelector('.js-loader')
  const header = document.querySelector('.js-header-main')
  const jumpLink = hero.querySelector('.js-explore-jump')
  const slide = hero.querySelector('.js-slide')
  const defaultColor = slide.getAttribute('data-color')
  const defaultNavColor = slide.getAttribute('data-nav-color')
  jumpLink.classList.add(defaultColor)
  header.classList.add(defaultNavColor)

  jumpLink.addEventListener('click', () => {
    jump('.js-explore-brand', {
      offset: -75
    })
  })
  setTimeout(() => loader && loader.classList.add('hide'), 250)
  setTimeout(() => header.classList.add('move'), 450)
}



// WEBPACK FOOTER //
// ./src/scripts/components/hide-loader.js